/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceSearchBody } from '../../models/service-search-body';
import { ServiceSortFieldName } from '../../models/service-sort-field-name';
import { SortDirection } from '../../models/sort-direction';
import { SubscriptionSubServicePagedList } from '../../models/subscription-sub-service-paged-list';

export interface SearchSubServices$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The search text to filter API
 */
  search?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * SUBSCRIPTION_NAME
 *   * SUBSERVICE_NAME
 */
  sortFieldName?: ServiceSortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search service
     */
    body?: ServiceSearchBody
}

export function searchSubServices(http: HttpClient, rootUrl: string, params?: SearchSubServices$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubServicePagedList>> {
  const rb = new RequestBuilder(rootUrl, searchSubServices.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionSubServicePagedList>;
    })
  );
}

searchSubServices.PATH = '/sub-service/search';
